<script>
export default {
  name: 'Gltf',

  props: {

    src: {
      type: String,
      required: true
    },

    part: {
      type: String,
      default: null
    },

    scale: {
      type: Number,
      default: 1
    }

  },

  computed: {

    component () {
      return this.part ? 'a-entity' : 'a-gltf-model'
    },

    bindings () {
      const scale = [this.scale, this.scale, this.scale].join(' ')

      return this.component === 'a-gltf-model'
        ? {
          src: this.src,
          scale
        }
        : {
          'gltf-part': 'src:' + this.src + (this.part ? ('; part: ' + this.part) : ''),
          scale
        }
    }

  }

}
</script>

<template>
  <component
    :is="component"
    v-bind="bindings"
    class="c-gltf"
  />
</template>
